export enum EnumGeofenceTypes {
    SecureZone_AlertOnExit = 1,
    InsecureZone_AlertOnEnter = 2
}